<app-mat-spinner-overlay
  *ngIf="showWaitingForDataSpinner == true"
  [overlay]="true"
>
</app-mat-spinner-overlay>

<div class="spacer"></div>
<div class="container container-border container-size">
  <h2>{{anwendungsname}}</h2>
</div>
  

<div class="spacer"></div>
<div class="container container-border container-size">
  <div class="row">
    <div class="col-md-12">
      Basierend auf Ihrer getroffenen Filterauswahl werden Ihnen nachfolgend die
      relevanten Tierwohl-Indikatoren aus der Literaturdatenbank angezeigt.
      Bitte beachten Sie, dass Indikatoren mit jeweils eigener Methodik in
      dieser Übersichtsanzeige mehrfach erscheinen können.
    </div>


    <div class="flexContainer">
      <div class="tree-width">
        <mat-card class="mat-elevation-z2 mt-4 p-0">
          <mat-toolbar
            [class]="
              currentSelected == null
                ? 'hintergrund-gesamt-geklickt'
                : 'hintergrund-gesamt'
            "
          >
            <mat-icon
              [class]="currentSelected == null ? 'icon-geklickt' : 'icon'"
              >notes</mat-icon
            >

            <div
              [class]="
                currentSelected == null ? 'datensätze-geklickt' : 'datensätze'
              "
            >
              <button
                class="mx-1 mehrere-zeilen-gesamt"
                mat-button
                (click)="searchEntry(null, null, showDoppelte, false)"
              >
                Gesamt
              </button>
              <span class="zahlen-padding">{{ gesamtSumme }}</span>
            </div>
          </mat-toolbar>
           
        
          <mat-tree
            [dataSource]="nestedDataSource"
            [treeControl]="nestedTreeControl"
            class="example-tree mat-tree-position"
          >
            <mat-nested-tree-node
              *matTreeNodeDef="let node; when: hasNestedChild"
            >
              <div
                [class]="
                  getShowTierart(node.tierart)
                    ? 'hintergrund-geklickt datensätze-geklickt'
                    : 'hintergrund'
                "
              >
                <button
                  [disabled]="
                    node.ausblenden == true || isBegleitIndikator == true
                  "
                  mat-icon-button
                  matTreeNodeToggle
                  [attr.aria-label]="'toggle ' + node.tierart"
                >
                  <mat-icon class="mat-icon-rtl-mirror">
                    {{
                      nestedTreeControl.isExpanded(node)
                        ? "expand_less"
                        : "expand_more"
                    }}
                  </mat-icon>
                </button>

                <button
                  mat-button
                  (click)="searchEntry(node.tierart, true, showDoppelte, false)"
                >
                  <div class="mehrere-zeilen">{{ node.tierart }}</div>
                </button>

                <span class="zahlen-padding">{{ node.anzahl }}</span>
              </div>
              <ul
                [class.example-tree-invisible]="
                  !nestedTreeControl.isExpanded(node)
                "
              >
                <ng-container matTreeNodeOutlet></ng-container>
              </ul>
            </mat-nested-tree-node>

            <mat-tree-node
              *matTreeNodeDef="let node"
              [class]="
                getShowTierart(node.tierart)
                  ? 'hintergrund-klein-geklickt'
                  : 'hintergrund-klein'
              "
            >
              <div
                [class]="
                  getShowTierart(node.tierart) ? 'datensätze-geklickt' : ''
                "
              >
                <button
                  mat-button
                  class="mr-1 mehrere-zeilen-unterpunkte"
                  (click)="
                    searchEntry(node.tierart, false, showDoppelte, false)
                  "
                >
                  <mat-icon class="mr-1" *ngIf="node.tierart">
                    subdirectory_arrow_right
                  </mat-icon>
                  {{ node.tierart }}
                </button>
                <span class="zahlen-padding">{{ node.anzahl }}</span>
              </div>
            </mat-tree-node>
          </mat-tree>
        </mat-card>
      </div>

      <div class="table-container-width">
        <div class="flexContainer">
          <div class="search-width">
            <mat-form-field appearance="standard">
              <mat-label style="color: black">Suche</mat-label>
              <input
                matInput
              (keyup)="applyFilter($event)"
              />

              <mat-icon matSuffix style="font-size: 2em">search</mat-icon>
            </mat-form-field>
          </div>
          <div class="doppelte-width">
            <mat-checkbox
              color="primary"
              class="doppelte-center"
              (change)="
                searchEntry(currentSelected, isParent, true, $event.checked)
              "
              >Zeige doppelte Einträge in Tabelle</mat-checkbox
            >
          </div>
        </div>

        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          (matSortChange)="sortData($event)"
          class="mat-elevation-z2 table-width"
          matSortActive="INDIKATOR_BEZEICHNUNG"
          matSortDirection="asc"
          matSortDisableClear
        >
          <ng-container matColumnDef="DATASET_SELECTED">
            <th
              *matHeaderCellDef
              class="mat-column-header-selecteddataset mat-column-header"
            >
              <mat-checkbox
                color="primary"
                [(ngModel)]="allSelected"
                (change)="onClickToggleSelectDataSet(allSelected)"
              >
              </mat-checkbox>
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="mat-column-cell-selecteddataset mat-column-cell"
            >
              <mat-checkbox
                color="primary"
                [(ngModel)]="element.checkedDownload"
                (change)="onClickToggleOneSelected(element.checkedDownload)"
              ></mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="INDIKATOR_BEZEICHNUNG">
            <th
              *matHeaderCellDef
              mat-sort-header
              class="mat-column-header-indikator mat-column-header"
            >
              Indikator
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="mat-column-cell-indikator mat-column-cell"
            >
              {{ element.indikatorBezeichnung }}
            </td>
          </ng-container>

          <ng-container matColumnDef="INDIKATOR_INFO">
            <th
              *matHeaderCellDef
              class="mat-column-header-info mat-column-header"
            ></th>
            <td
              mat-cell
              *matCellDef="let element"
              matTooltip="{{ element.indikatorBeschreibungEins }}"
              class="mat-column-cell-info mat-column-cell"
            >
              <fa-icon [icon]="faInfoCircle" class="mx-1 icon-info"
                >info</fa-icon
              >
            </td>
          </ng-container>

          <ng-container matColumnDef="QUELLE_INDIKATOR">
            <ng-container *ngIf="isBegleitIndikator == false">
              <th
                *matHeaderCellDef
                mat-sort-header
                class="mat-column-header-quelle mat-column-header"
              >
                Quelle
              </th>

              <td mat-cell *matCellDef="let element" class="mat-column-cell">
                <ng-container
                  *ngIf="element.quelleIndikator.includes('www.')"
                  class="mat-column-cell-quelle-web"
                >
                  {{ element.quelleIndikator }}
                </ng-container>
                <ng-container
                  *ngIf="element.quelleIndikator.includes('www.') != true"
                  class="mat-column-cell-quelle"
                >
                  {{ element.quelleIndikator }}
                </ng-container>
              </td>
            </ng-container>

            <ng-container *ngIf="isBegleitIndikator == true">
              <th
                *matHeaderCellDef
                mat-sort-header
                class="
                  mat-column-header-quelle-begleitindikator mat-column-header
                "
              >
                Quelle
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="mat-column-cell-quelle-begleitindikator mat-column-cell"
              >
                {{ element.quelleIndikator }}
              </td>
            </ng-container>
          </ng-container>

          <ng-container matColumnDef="DIMENSION">
            <th
              mat-sort-header
              *matHeaderCellDef
              class="mat-column-header-dimension mat-column-header"
            >
              Dimension
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="mat-column-cell-dimension mat-column-cell"
            >
              {{ element.dimension }}
            </td>
          </ng-container>

          <ng-container matColumnDef="ID_IND">
            <th
              mat-sort-header
              *matHeaderCellDef
              class="mat-column-header-idnr mat-column-header"
            >
              ID-Nr.
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="mat-column-cell-idnr mat-column-cell"
            >
              {{ element.idInd }}
            </td>
          </ng-container>

          <ng-container matColumnDef="DOWNLOAD">
            <th
              *matHeaderCellDef
              class="mat-column-header-download mat-column-header"
            ></th>
            <td
              mat-cell
              *matCellDef="let element"
              class="mat-column-cell-download mat-column-cell"
            >
              <fa-icon
                [icon]="faDownload"
                class="mx-1 download-icon"
                (click)="onDownloadPdfSynopseSingle(element)"
                >faDownload</fa-icon
              >
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-card class="col-md-12">
          <div class="row">
            <div class="col-md-4">
              <mat-paginator
                [pageSize]="10"
                [pageSizeOptions]="[10, 20, 50]"
                [showFirstLastButtons]="true"
                (page)="pageChanged()"
              ></mat-paginator>
            </div>
            
            <div class="col-md-8">
              <span class="buttons-right">
                <mat-checkbox
                color="primary"
                class="mt-3 checkbox-padding-right"
                (change)="
                  toggleAllInOne()
                "
                >Auswahl in einem PDF zusammenführen</mat-checkbox
              >
                <button
                  (click)="onDownloadPdfSynopseMulti(true)"
                  mat-raised-button
                  color="primary"
                  class="custom-btn mt-3 buttons-right"
                  type="button"
                >
                  <fa-icon [icon]="faDownload" class="mx-1 icon-arrow"></fa-icon>
                  Download
                </button>

              </span>

            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>

  <div class="spacer"></div>
  <mat-card>
    <div class="row">
      <div class="col-md-2">
        <button
          (click)="zurAuswahlseite()"
          mat-raised-button
          color="primary"
          class="custom-btn mt-3"
          type="button"
        >
          <fa-icon [icon]="faArrowLeft" class="mx-1 icon-arrow"></fa-icon>
          Zur Auswahl
        </button>
      </div>
    </div>
  </mat-card>
</div>
<div class="spacer"></div>
